import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { IdiomaService } from 'src/app/services/idioma.service';
import { ColumnaOrden, Orden } from '../models/columna-orden';

@Component({
  selector: 'app-ordenador',
  templateUrl: './ordenador.component.html',
  styleUrls: ['./ordenador.component.css']
})
export class OrdenadorComponent implements OnInit, OnDestroy {

  @Input() columnas: ColumnaOrden[] = [];

  @Input() campo: string;
  @Input() direccion: string = 'asc';

  @Output() ordenar = new EventEmitter<Orden>();

  public t: any;
  private subscripcionTextos: Subscription;

  constructor(private _idioma: IdiomaService) { }

  ngOnInit(): void {
    this.subscripcionTextos = this._idioma.getTextos$().subscribe(texto => {
      this.t = texto;
    });
  }

  ngOnDestroy(): void {
    if (this.subscripcionTextos) {
      this.subscripcionTextos.unsubscribe();
    }
  }

  onOrdenar(): void {
    if (!this.campo) {
      return;
    }

    this.ordenar.emit({ campo: this.campo, direccion: this.direccion || 'asc' });
  }
}
